export default __webpack_public_path__ + "static/media/SARASWATI.ea690d5d.JPG";